
const productutils = {
    // if sectors are energy, insurance,investments, mortgage & loans, retail, telecom, travel & leisure
    condition1: function (view) {
        let sectots = view.$store.getters['ProductData/getSubmittableSectors'],
            $c = view.$c.sector,
            sec = [$c.energy, $c.investment_annulities, $c.insurance, $c.mortgage_loan, $c.retail, $c.telecomm, $c.travel_leisure,
            $c.automotive, $c.banking, $c.credit_card, $c.hr_payroll],
            fil = []
        sectots.forEach(function (o) {
            fil.push(sec.includes(o[0]))
        })
        return fil.includes(true)
    },
    condition2: function (view) {
        let sectots = view.$store.getters['ProductData/getSubmittableSectors'],
            d = false
        sectots.forEach(function (o) {
            if (o[0] === view.$c.sector.banking || o[0] === view.$c.sector.credit_card) {
                d = true
            }
        })
        return d
    },
    hasInvestmentOrInsurance: function (view) {
        let sectots = view.$store.getters['ProductData/getSubmittableSectors'],
            $c = view.$c.sector,
            sec = [$c.investment_annulities, $c.insurance]
        if (sectots.length === 1) {
            return sec.includes(sectots[0][0])
        } else if (sectots.length === 2) {
            return sec.includes(sectots[0][0]) && sec.includes(sectots[1][0])
        }
        return false
    },
    paymentCard: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId'],
            t = view.$utils
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: `${view.$url("PRODUCT_PAYMENT_CARD")}/${product_id}`,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    typeof payload.tier_1_cash_advance_regular_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier1CashAdvanceRegularApr', payload.tier_1_cash_advance_regular_apr)
                    typeof payload.tier_2_cash_advance_regular_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier2CashAdvanceRegularApr', payload.tier_2_cash_advance_regular_apr)
                    typeof payload.cash_advance_regular_rate_type === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceRegularRateType', payload.cash_advance_regular_rate_type)
                    typeof payload.tier_3_cash_advance_regular_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier3CashAdvanceRegularApr', payload.tier_3_cash_advance_regular_apr)
                    typeof payload.annual_fee_details === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardAnnualFeeDetails', payload.annual_fee_details)
                    typeof payload.application_type === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardApplicationType', payload.application_type)
                    typeof payload.balance_transfer_introductory_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferIntroductoryApr', payload.balance_transfer_introductory_apr)
                    typeof payload.balance_transfer_introductory_fee_details === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferIntroductoryFeeDetails', payload.balance_transfer_introductory_fee_details)
                    typeof payload.balance_transfer_introductory_fee_period_months === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferIntroductoryFeePeriodMonths', payload.balance_transfer_introductory_fee_period_months)
                    typeof payload.balance_transfer_introductory_maximum_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferIntroductoryMaximumFee', payload.balance_transfer_introductory_maximum_fee)
                    typeof payload.balance_transfer_introductory_minimum_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferIntroductoryMinimumFee', payload.balance_transfer_introductory_minimum_fee)
                    typeof payload.balance_transfer_introductory_period_months === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferIntroductoryPeriodMonths', payload.balance_transfer_introductory_period_months)
                    typeof payload.balance_transfer_introductory_usage_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferIntroductoryUsageFee', payload.balance_transfer_introductory_usage_fee)
                    typeof payload.balance_transfer_maximun_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferMaximunFee', payload.balance_transfer_maximun_fee)
                    typeof payload.balance_transfer_minimum_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferMinimumFee', payload.balance_transfer_minimum_fee)
                    typeof payload.balance_transfer_regular_apr_detail === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferRegularAprDetail', payload.balance_transfer_regular_apr_detail)
                    typeof payload.balance_regular_transfer_rate_type === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferRegularRateType', payload.balance_regular_transfer_rate_type)
                    typeof payload.balance_transfer_usage_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardBalanceTransferUsageFee', payload.balance_transfer_usage_fee)
                    if (typeof payload.card_network !== 'undefined' && payload.card_network !== '') {
                        view.$store.dispatch('ProductData/setPaymentCardCardNetwork', t.str2array(payload.card_network))
                    }
                    typeof payload.cash_advance_introductory_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceIntroductoryApr', payload.cash_advance_introductory_apr)
                    typeof payload.cash_advance_introductory_fee_details === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceIntroductoryFeeDetails', payload.cash_advance_introductory_fee_details)
                    typeof payload.cash_advance_introductory_fee_period_months === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceIntroductoryFeePeriodMonths', payload.cash_advance_introductory_fee_period_months)
                    typeof payload.cash_advance_introductory_maximum_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceIntroductoryMaximumFee', payload.cash_advance_introductory_maximum_fee)
                    typeof payload.cash_advance_introductory_minimum_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceIntroductoryMinimumFee', payload.cash_advance_introductory_minimum_fee)
                    typeof payload.cash_advance_introductory_period_months === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceIntroductoryPeriodMonths', payload.cash_advance_introductory_period_months)
                    typeof payload.cash_advance_introductory_usage_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceIntroductoryUsageFee', payload.cash_advance_introductory_usage_fee)
                    typeof payload.cash_advance_maximum_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceMaximumFee', payload.cash_advance_maximum_fee)
                    typeof payload.cash_advance_minimum_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceMinimumFee', payload.cash_advance_minimum_fee)
                    typeof payload.cash_advance_usage_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceUsageFee', payload.cash_advance_usage_fee)
                    typeof payload.late_fee_details === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardLateFeeDetails', payload.late_fee_details)
                    typeof payload.maximum_card_limit === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardMaximumCardLimit', payload.maximum_card_limit)
                    
                    typeof payload.MonthlyMaintenanceFee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardMonthlyMaintenanceFee', payload.MonthlyMaintenanceFee)
                    typeof payload.StandardMonthlyMaintenanceFee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardStandardMonthlyMaintenanceFee', payload.StandardMonthlyMaintenanceFee)
                    
                    typeof payload.minimum_card_limit === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardMinimumCardLimit', payload.minimum_card_limit)
                    typeof payload.overlimit_fee_details === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardOverlimitFeeDetails', payload.overlimit_fee_details)
                    typeof payload.perchase_regular_rate_type === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardPerchaseRegularRateType', payload.perchase_regular_rate_type)
                    if (typeof payload.reward_program_emphasis !== 'undefined' && payload.reward_program_emphasis != '') {
                        view.$store.dispatch('ProductData/setPaymentCardRewardProgramEmphasis', t.str2array(payload.reward_program_emphasis))
                    }
                    if (typeof payload.primary_card_level !== 'undefined' && payload.primary_card_level !== '') {
                        view.$store.dispatch('ProductData/setPaymentCardPrimaryCardLevel', t.str2array(payload.primary_card_level))
                    }
                    // typeof payload.productID === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardProductID', payload.productID)
                    typeof payload.purchase_introductory_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardPurchaseIntroductoryApr', payload.purchase_introductory_apr)
                    typeof payload.purchase_introductory_period_months === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardPurchaseIntroductoryPeriodMonths', payload.purchase_introductory_period_months)
                    typeof payload.purchase_regular_apr_detail === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardPurchaseRegularAprDetail', payload.purchase_regular_apr_detail)
                    typeof payload.reloadable === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardReloadable', payload.reloadable)
                    typeof payload.reward_program === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardRewardProgram', t.int2bool(payload.reward_program))
                    typeof payload.reward_program_rate === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardRewardProgramRate', payload.reward_program_rate)
                    if (typeof payload.secondary_card_level !== 'undefined' && payload.secondary_card_level !== '') {
                        view.$store.dispatch('ProductData/setPaymentCardSecondaryCardLevel', t.str2array(payload.secondary_card_level))
                    }
                    typeof payload.PenaltyAPR === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardPenaltyApr', payload.PenaltyAPR)
                    typeof payload.PenaltyAPRDetails === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardPenaltyAprDetails', payload.PenaltyAPRDetails)
                    typeof payload.tier_1_annual_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier1AnnualFee', payload.tier_1_annual_fee)
                    typeof payload.tier_1_balance_transfer_regular_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier1BalanceTransferRegularApr', payload.tier_1_balance_transfer_regular_apr)
                    typeof payload.tier_1_late_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier1LateFee', payload.tier_1_late_fee)
                    typeof payload.tier_1_overlimit_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier1OverlimitFee', payload.tier_1_overlimit_fee)
                    typeof payload.tier_1_purchase_regular_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier1PurchaseRegularApr', payload.tier_1_purchase_regular_apr)
                    typeof payload.tier_2_annual_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier2AnnualFee', payload.tier_2_annual_fee)
                    typeof payload.tier_2_balance_transfer_regular_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier2BalanceTransferRegularApr', payload.tier_2_balance_transfer_regular_apr)
                    typeof payload.tier_2_late_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier2LateFee', payload.tier_2_late_fee)
                    typeof payload.tier_2_overlimit_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier2OverlimitFee', payload.tier_2_overlimit_fee)
                    typeof payload.tier_2_purchase_regular_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier2PurchaseRegularApr', payload.tier_2_purchase_regular_apr)
                    typeof payload.tier_3_annual_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier3AnnualFee', payload.tier_3_annual_fee)
                    typeof payload.tier_3_balance_transfer_regular_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier3BalanceTransferRegularApr', payload.tier_3_balance_transfer_regular_apr)
                    typeof payload.tier_3_late_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier3LateFee', payload.tier_3_late_fee)
                    typeof payload.tier_3_overlimit_fee === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier3OverlimitFee', payload.tier_3_overlimit_fee)
                    typeof payload.tier_3_purchase_regular_apr === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardTier3PurchaseRegularApr', payload.tier_3_purchase_regular_apr)
                    typeof payload.cash_advance_regular_apr_details === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardCashAdvanceRegularAprDetails', payload.cash_advance_regular_apr_details)
                    typeof payload.promotional_purchase_pricing_usage_offer === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardPromotionalPricingUsageOffer', payload.promotional_purchase_pricing_usage_offer)
                    typeof payload.promotional_purchase_pricing_usage_offer_months === 'undefined' ? '' : view.$store.dispatch('ProductData/setPaymentCardPromotionalPricingUsageOfferMonths', payload.promotional_purchase_pricing_usage_offer_months)
                }
            }).catch(e => console.log(e))
        }
    },
    creditAccessCheck: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'creditAccessCheck/' + product_id,
                type: 'GET'
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    view.$utils.stateProductActions(view, 'creditAccessCheckActions', payload)
                }
            })
        }
    },
    energy: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'energy/' + product_id,
                type: 'GET'
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    view.$utils.stateProductActions(view, 'energyActions', payload)
                }
            })
        }
    },
    promotions: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'promotions/' + product_id,
                type: 'GET'
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    console.log(r.payload);
                    let payload = r.payload
                    let promotions = payload.promotions
                    if (Array.isArray(promotions) && promotions.length) {
                        view.$store.dispatch("ProductData/setPromotions", [])
                        view.$store.dispatch("ProductData/setPromotions", promotions)
                    }
                    view.$store.dispatch("ProductData/setHoliday", payload.holiday);
                    view.$store.dispatch('ProductData/setSaleType', payload.sale_type)
                }
            })
        }
    },
    advertisers: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'advertiser/' + product_id,
                type: 'GET'
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    console.log(r.payload);
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        let advertisers = payload[0]
                        view.$store.dispatch('ProductData/setAdvertiserAddress', advertisers.address)
                        view.$store.dispatch('ProductData/setAdvertiserCity', advertisers.city)
                        view.$store.dispatch('ProductData/setAdvertiserState', advertisers.state_province)
                        view.$store.dispatch('ProductData/setAdvertiserZipcode', advertisers.zipcode)
                        view.$store.dispatch('ProductData/setAdvertiserPhone', advertisers.phone)
                        view.$store.dispatch('ProductData/setAdvertiserUrl', advertisers.url)
                    }
                }
            })
        }
    },
    productIncentive: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'productIncentive/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    view.$utils.stateProductActions(view, 'productIncentiveActions', payload)
                }
            })
        }
    },
    deliveryMethod: function (view) {
        let t = this
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'deliveryMethod/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        let delivery_method = payload[0]
                        if (typeof delivery_method.delivery_method_id !== 'undefined') {
                            view.$store.dispatch('ProductData/set_delivery_method', delivery_method.delivery_method_id)
                            let deliveryMethod = view.$store.getters['ProductData/getDeliveryMethod']
                            if (deliveryMethod === 1 || deliveryMethod === 3 || deliveryMethod === 7) {
                                t.deliveryType(view)
                                t.postage(view)
                                t.preSorted(view)
                                t.packageType(view)
                            }
                        }
                    }
                }
            })
        }
    },
    deliveryType: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'deliveryType/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        let delivery_type = payload[0]
                        if (typeof delivery_type.delivery_type_id !== 'undefined') {
                            view.$store.dispatch('ProductData/set_delivery_type', delivery_type.delivery_type_id)
                        }
                    }
                }
            })
        }
    },
    postage: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'postage/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        let postage = payload[0]
                        if (typeof postage.postage_id !== 'undefined') {
                            view.$store.dispatch('ProductData/set_delivery_postage', postage.postage_id)
                        }
                    }
                }
            })
        }
    },
    preSorted: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'preSorted/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        let preSorted = payload[0]
                        if (typeof preSorted.presorted_id !== 'undefined') {
                            view.$store.dispatch('ProductData/set_delivery_pre_sorted', preSorted.presorted_id)
                        }
                    }
                }
            })
        }
    },
    packageType: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'packageType/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        let packageType = payload[0]
                        if (typeof packageType.package_type_id !== 'undefined') {
                            view.$store.dispatch('ProductData/set_delivery_package_type', packageType.package_type_id)
                        }
                    }
                }
            })
        }
    },
    groupSize: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'groupSize/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        view.$store.dispatch('ProductData/setGroupSize', payload)
                    }
                }
            })
        }
    },
    riders: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'riders/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        view.$store.dispatch('ProductData/setRiders', payload)
                    }
                }
            })
        }
    },
    issueType: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'issueType/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        view.$store.dispatch("ProductData/setIssueType", payload);
                    }
                }
            })
        }
    },
    faceAmount: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'faceAmount/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        view.$store.dispatch("ProductData/setFaceAmount", payload);
                    }
                }
            })
        }
    },
    termLength: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'termLength/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        view.$store.dispatch("ProductData/setTermLength", payload);
                    }
                }
            })
        }
    },
    electronicType: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        console.log("electronic type entered")
        if (product_id !== '' && !isNaN(product_id)) {
            console.log("electronic type ep starts here")
            view.$fetch({
                url: view.$url('API') + 'electronicType/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    if (Array.isArray(payload) && payload.length) {
                        let elec_type = ''
                        payload.forEach(function (o) {
                            //arr.push(o.electronic_id)
                            elec_type = o.electronic_id
                        })
                        let media_channel = view.$store.getters["ProductData/getStateMediaChannel"];
                        let current_media_channel_elec_type = view.$store.getters['ProductData/getMediaChannelElectronicType'];

                        let media_elec_type = ''
                        if (current_media_channel_elec_type == '') {
                            media_elec_type = ''
                        } else {
                            media_elec_type = current_media_channel_elec_type
                        }
                        if (media_channel == 3) {
                            if (elec_type != '')
                                media_elec_type = elec_type
                            else
                                media_elec_type.push(1)


                            console.log('condition coming' + elec_type)
                            if (current_media_channel_elec_type == "")
                                view.$store.dispatch('ProductData/setMediaChannelElectronicType', media_elec_type)
                        } else {
                            view.$store.dispatch('ProductData/setMediaChannelElectronicType', elec_type)
                        }
                    }
                }
            }).catch((e) => {
                if (e.responseJSON.statusCode === 404) {
                    let media_channel = view.$store.getters["ProductData/getStateMediaChannel"];
                    let current_media_channel_elec_type = view.$store.getters['ProductData/getMediaChannelElectronicType'];
                    let media_elec_type = ''
                    if (current_media_channel_elec_type == '') {
                        media_elec_type = ''
                    } else {
                        media_elec_type = current_media_channel_elec_type
                    }
                    if (media_channel == 3) {
                        if (current_media_channel_elec_type == "") {
                            media_elec_type = 1
                            view.$store.dispatch('ProductData/setMediaChannelElectronicType', media_elec_type)
                        }



                    }
                }
            })
        }
    },
    productInfo: function (view) {
        let product_id = view.$store.getters['ProductData/getProductId']
        if (product_id !== '' && !isNaN(product_id)) {
            view.$fetch({
                url: view.$url('API') + 'productInfo/' + product_id,
                type: 'GET',
            }, {
                operation: 'view',
                vueScope: view
            }).then(function (r) {
                if (r.statusCode === 200) {
                    let payload = r.payload
                    view.$refs.topProgress.done()
                    typeof payload.observed_traffic_source === 'undefined' ? '' : view.$store.dispatch('ProductData/setProductObservedTrafficSource', payload.observed_traffic_source)
                    typeof payload.product_comment === 'undefined' ? '' : view.$store.dispatch('ProductData/setProductComment', payload.product_comment)
                }
            }).catch(function () {
                view.$refs.topProgress.done()
            })
        }
    },
}

export default productutils